import {TENANT_BASE_URL} from "../../../common/Config/UrlHelper";
import DatatableHelperMixin from "../../../common/Mixin/Global/DatatableHelperMixin";
import {formatDateToLocal} from "../../../common/Helper/Support/DateTimeHelper";
import {DepartmentFilterMixin, UserFilterMixin} from "./FilterMixin";
import {axiosGet} from "../../../common/Helper/AxiosHelper";

export default {
    mixins: [DatatableHelperMixin, DepartmentFilterMixin],
    data() {
        return {
            options: {
                name             : this.$t('access_logs'),
                url              : `${TENANT_BASE_URL}access-logs`,
                showHeader       : true,
                showSearch       : false,
                tableShadow      : false,
                tablePaddingClass: 'pt-primary',
                columns          : [
                    {
                        title    : this.$t('action'),
                        type     : 'custom-html',
                        key      : 'type',
                        isVisible: true,
                        modifier : (data, row) => {
                            if (data === 'logout') {
                                return '<div class="badge badge-pill badge-danger">' + this.$t('logout') + '</div>';
                            }
                            return '<div class="badge badge-pill badge-primary">' + this.$t('login') + '</div>';
                        }
                    },
                    {
                        title    : this.$t('user'),
                        type     : 'custom-html',
                        key      : 'user',
                        isVisible: true,
                        modifier : (value) => value.full_name
                    },
                    {
                        title    : this.$t('IP'),
                        type     : 'text',
                        key      : 'ip_address',
                        isVisible: true,
                    },
                    {
                        title    : this.$t('type'),
                        type     : 'custom-html',
                        key      : 'device',
                        isVisible: true,
                        modifier : (value) => this.$t(value)
                    },
                    {
                        title    : this.$t('user_agent'),
                        type     : 'text',
                        key      : 'user_agent',
                        isVisible: true,
                    },
                    {
                        title    : this.$t('created'),
                        type     : 'custom-html',
                        key      : 'created_at',
                        isVisible: true,
                        modifier : (value) => value ? formatDateToLocal(value) : 'N/A'
                    },
                ],
                filters          : [
                    {
                        title         : this.$t('department'),
                        type          : "multi-select-filter",
                        key           : "departments",
                        option        : [],
                        listValueField: 'name',
                        permission    : !!this.$can('view_departments')
                    },
                    {
                        title         : this.$t('users'),
                        type          : "multi-select-filter",
                        key           : "users",
                        option        : [],
                        listValueField: 'employee_name',
                        permission    : !!this.$can('view_all_attendance') && !!this.$can('view_users')
                    },
                    {
                        title : this.$t('created'),
                        type  : "range-picker",
                        key   : "date",
                        option: ["today", "thisMonth", "last7Days", "thisYear"]
                    },
                ],
                paginationType   : "pagination",
                responsive       : true,
                rowLimit         : 10,
                showAction       : true,
                orderBy          : 'desc',
                actionType       : 'default',
                actions          : [],
            }
        }
    },
    created() {
        this.getFilterValues()
    },
    methods: {
        getFilterValues(value) {
            if (value && value.departments) {
                axiosGet(this.apiUrl.TENANT_SELECTABLE_USER + '?departments=' + value.departments).then(({data}) => {
                    this.options.filters.find(fl => fl.key === 'users' && fl.type === 'multi-select-filter').option = data;
                })
            } else {
                axiosGet(this.apiUrl.TENANT_SELECTABLE_USER).then(({data}) => {
                    this.options.filters.find(fl => fl.key === 'users' && fl.type === 'multi-select-filter').option = data;
                })
            }
        },
    },
}
